import React from "react";
import { Row, Col, Form, Button } from "react-bootstrap";

const VerificationActions = ({
    isSubmitting,
    showRejectForm, setShowRejectForm,
    rejectReason, setRejectReason,
    onApprove,
    onReject,
}) => {
    return (
        <div className="border rounded p-4 mt-4 bg-light">
            <h5 className="mb-3">Verifikasi Permohonan</h5>

            {!showRejectForm ? (
                <div className="text-center">
                    <Button
                        variant="success"
                        className="me-2"
                        disabled={isSubmitting}
                        onClick={onApprove}
                    >
                        {isSubmitting ? "Memproses..." : "Setujui & Kirim Email"}
                    </Button>
                    <Button
                        variant="danger"
                        disabled={isSubmitting}
                        onClick={() => setShowRejectForm(true)}
                    >
                        Tolak / Tunda
                    </Button>
                </div>
            ) : (
                <Form onSubmit={onReject}>
                    <Form.Group as={Row} className="form-group">
                        <Form.Label column sm="3" className="control-label mb-0">
                            Alasan Penolakan*
                        </Form.Label>
                        <Col sm="9">
                            <Form.Control
                                as="textarea"
                                rows="3"
                                placeholder="Contoh: Dokumen NIB belum sesuai, mohon unggah ulang dokumen yang jelas terbaca."
                                value={rejectReason}
                                onChange={(e) => setRejectReason(e.target.value)}
                                required
                            />
                        </Col>
                    </Form.Group>
                    <div className="text-center mt-3">
                        <Button type="submit" variant="danger" className="me-2" disabled={isSubmitting}>
                            {isSubmitting ? "Memproses..." : "Kirim Penolakan & Email"}
                        </Button>
                        <Button
                            type="button"
                            variant="secondary"
                            disabled={isSubmitting}
                            onClick={() => setShowRejectForm(false)}
                        >
                            Batal
                        </Button>
                    </div>
                </Form>
            )}
        </div>
    );
};

export default VerificationActions;